import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import style from  '../../../../sass/pages/profile/profile.module.scss'

const LanguageInput = ({state, setState, enabled}) => {
    const {t} = useTranslation()
    const handleChange = (e) => {
        if(!e.target.value) {
            setState("")
            return
        }
        setState(e.target.value)
    }

    useEffect(() => {
        if (!state) {
            setState("tr")
            return
        }
    }, [setState, state])

    return (
        <div className="grid grid-cols-8 xs:grid-cols-12 items-center">
            <span className='col-span-4 text-xs text-left font-bold'>
                {t("user.inputs.language.title")}
            </span>
            <select
                className={`${style.select} col-span-4 text-xs text-left font-bold`}
                id="sender-region"
                value={state["sender-region"]}
                onInput={handleChange}
                disabled={!enabled}
            >
                <option
                    selected={state === "tr"}
                    value={"tr"}
                >
                    {"Türkçe"}
                </option>
                <option
                    selected={state === "ru"}
                    value={"ru"}
                >
                    {"Русский"}
                </option>
            </select>
        </div>
  )
}

export default LanguageInput